import { render, staticRenderFns } from "./GrantsConstraintsPlansSlidDetailsAdd.vue?vue&type=template&id=7befb145&"
import script from "./GrantsConstraintsPlansSlidDetailsAdd.vue?vue&type=script&lang=js&"
export * from "./GrantsConstraintsPlansSlidDetailsAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports